import type { AppProps } from "next/app";
import QDReport, { initSession } from "@/components/QDReport";
import Cookies from "js-cookie";
import Head from "next/head";
import FloatDownloadButton from "@/components/FloatDownloadButton";
import "@/styles/globals.scss";
import { setUtm } from "@/utils/utm";
import GAReport from "../src/components/GAGroup";

// 浏览器
if (typeof window !== "undefined") {
  Cookies.set("areaId", "4");
  Cookies.set("appId", "1001");
  setUtm();
  initSession();
}

type CpnExtraOptions = {
  hideFloatDownloadButton?: boolean; // 是否隐藏悬浮下载按钮
};

function App(props: AppProps) {
  const { pageProps } = props;
  const Component = props.Component as typeof props.Component & CpnExtraOptions;
  return (
    <>
      <GAReport />
      <Head>
        <meta
          name="viewport"
          content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, viewport-fit=cover"
        />
      </Head>
      {!Component.hideFloatDownloadButton && <FloatDownloadButton />}
      <Component {...pageProps} />
    </>
  );
}

const MyApp = QDReport(App);

export default MyApp;
